// ============================================================
// LexNova — Color Palette
// Extracted from brand designs
// ============================================================

export const COLORS = {
  // Primary brand purples
  purple: {
    50:  '#f5f0ff',
    100: '#ede0ff',
    200: '#d9bfff',
    300: '#bf8fff',
    400: '#a855f7',
    500: '#9333ea',   // Main brand purple
    600: '#7c22ce',
    700: '#6b21a8',
    800: '#581c87',
    900: '#3b0764',
  },

  // Accent magenta/pink (CTA buttons, highlights)
  magenta: {
    300: '#f472b6',
    400: '#ec4899',
    500: '#db2777',   // Main CTA color
    600: '#be185d',
  },

  // Violet (logo gradient endpoint)
  violet: {
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
  },

  // Dark backgrounds
  dark: {
    900: '#0d0d14',   // Deepest background
    800: '#13111e',   // Page background dark
    750: '#181629',
    700: '#1e1b2e',   // Card background dark
    600: '#26233a',
    500: '#312e48',   // Elevated card
    400: '#3d3a54',   // Border / divider dark
  },

  // Light backgrounds
  light: {
    50:  '#ffffff',
    100: '#f8f6ff',   // Page background light
    200: '#f0ebff',
    300: '#e8e0ff',
    400: '#d1c4f0',
  },

  // Neutral grays
  gray: {
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Semantic
  success: '#22c55e',
  warning: '#f59e0b',
  error:   '#ef4444',
  info:    '#3b82f6',

  // Gradients (as strings for CSS)
  gradients: {
    brand:       'linear-gradient(135deg, #9333ea 0%, #db2777 100%)',
    brandLight:  'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
    heroDark:    'linear-gradient(180deg, #0d0d14 0%, #13111e 100%)',
    heroLight:   'linear-gradient(180deg, #f0ebff 0%, #ffffff 100%)',
    cardDark:    'linear-gradient(145deg, #1e1b2e 0%, #26233a 100%)',
    purpleMesh:  'radial-gradient(ellipse at 30% 40%, rgba(147,51,234,0.25) 0%, transparent 60%), radial-gradient(ellipse at 80% 10%, rgba(219,39,119,0.15) 0%, transparent 50%)',
    logoGrad:    'linear-gradient(135deg, #bf00ff 0%, #7c22ce 100%)',
  },
} as const;

export default COLORS;
